import { useTranslation } from 'react-i18next';

// interface Props {
//     type: string
// }

export const OrderTypeBadge = (props) => {
    const { t } = useTranslation();

    return <span className="text-[13px] font-medium capitalize">{t(`order_type.${props.type}`)}</span>;
};
